import { render, staticRenderFns } from "./programOfficerAssignedTrainings.vue?vue&type=template&id=682652fa&scoped=true"
import script from "./programOfficerAssignedTrainings.vue?vue&type=script&lang=js"
export * from "./programOfficerAssignedTrainings.vue?vue&type=script&lang=js"
import style0 from "./programOfficerAssignedTrainings.vue?vue&type=style&index=0&id=682652fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682652fa",
  null
  
)

export default component.exports